export const events = {
  changePayrollStatus: 'Change payroll period status + Notify collaborators',
  validateSupplement: 'Validate supplement',
  createSupplement: 'Create supplement',
  updateSupplement: 'Update supplement',
  gotoReports: 'Go to Reports',
  importSupplments: 'Import supplements (start)',
  confirmImportSupplement: 'Confirm supplements import (end)',
  importResult: 'Import results (start)',
  selectResultFile: 'Select a result file',
  importSelectedResultFile: 'Import selected result file',
  downloadTemplate: 'Download payroll summary template',
  continueToMapDataToConceptStep: 'Continue to map result data to concept step',
  openAddNewConceptModal: 'Open add new result concept modal',
  addNewConcept: 'Add a new result concept',
  continueToFinalResultImportStep: 'Go to the result final import step',
  selectPayrollResultData: 'Selects payroll results data',

  manuallyAssignEmployeeToResultItem:
    'Manually assign employee to a result item in import result final step',
  manuallyUnAssignEmployeeToResultItem:
    'Manually unassign employee to a result item in import result final step',

  confirmImportResults: 'Import (n) results',
  generatePayment: 'Generate payment (start)',
  generatePaymentFromSelectedResult: 'Generate payment from selected results',
  generateSEPA: 'Generate SEPA (final step)',
  markAsPaid: 'Mark as paid',
  gotoManageCategoriesAndTitle: 'Go to manage categories and titles',
  selectSupplementTitle: 'Select title of supplement',
  learnHowToChangeTitle: 'Learn how to change the predefined titles',
  goToIncidencesTab: 'Go to incidences tab',
  goToIncidencesMessagesTab: 'Go to messages tab',
  createManualIncidenceSubmit: 'Create manual incidence submit',
  setupPayroll: 'Setup the payroll app',
  visitPayrollPage: 'Visit payroll page',
  goToFinanceWorkspace: 'Go to finance workspace',
  changeDashboardVersion: 'Change dashboard version',
  seenSummerReleaseModal: 'Payroll summer release modal complete',
  closedSummerReleaseModal: 'Payroll summer release modal incomplete',
  goToEventSettings: 'Payroll export event settings',
  goToEventLanding: 'Payroll export event landing',
  userAcknowledgesFirstHint: 'Payroll user clicks on next 1st hint popover tag',
  userAcknowledgesAllHints: 'Payroll user clicks on got it 2nd hint popover export button',
  userClicksExportData: 'Payroll user clicks on export data button',
  userClicksSyncData: 'Payroll user clicks on a3innuva sync button',
  syncData: 'Sync data',
  userClicksOnPolicyTag: 'Payroll user clicks on policy tag button',
  userClicksOnGoToUpdates: 'User clicks on go to updates button',
  userClicksOnStartNow: 'User clicks on start now button',
  userAcknowledgesFirstHintEmployeeUpdates: 'Payroll employee updates user clicks on next 1st hint',
  userAcknowledgesAllHintsEmployeeUpdates:
    'Payroll employee updates user clicks on got it 2nd hint',
  userTogglesExplanationCard: 'Payroll landing page user interacts with explanation card',
  userClicksStartNowInOnboarding: 'Payroll landing page user click on start now',
  userLandsInWelcomeOnboarding: 'Payroll user lands in welcome onboarding',
  userLandsInPayrollPolicyOnboarding: 'Payroll user lands in policy onboarding',
  userLandsInUpdatesOnboarding: 'Payroll user lands in updates onboarding',
  userOnboardingCompleted: 'Payroll user onboarding completed',
  userCreatesNewPolicy: 'Payroll user creates a new policy',
  payrollOnboardingEnableUpdate: 'Payroll onboarding enable update',
  userStartPayrollCycle: 'Payroll user starts cycle',
  userClicksOnImportPayrollCycleResults: ' Payroll user clicks on import payroll cycle results',
  userClickOnViewPayrollUpdates: 'Payroll user clicks on view payroll updatea',
  userClicksOnNewPayrollPayment: 'Payroll user clicks on new payment',
  userClicksOnChangePolicySelector: 'Payroll user clicks on change policy selector',
  userClicksOnChangePolicyPeriodSelector: 'Payroll user clicks on change policy period selector',
  userClicksOnReviewPayrollIssues: 'Payroll user clicks on review payroll issues',
  userClicksOnPayrollCollaboration: 'Payroll user clicks on collaboration mode',
  userClicksOnPayrollImportSupplements: 'Payroll user clicks on import supplements',
  userClicksOnPayrollContinueCycle: 'Payroll user clicks on continue cycle',
  userClicksOnPayrollPreviousCycle: 'Payroll user clicks on previous cycle',
  userClicksOnPayrollExitCycle: 'Payroll user clicks on exit cycle',

  initImportPayrollSummaryFromExternal:
    'Start importing the payroll summary from an external module',
  finishImportPayrollSummaryFromExternal:
    'Finish importing the payroll summary from an external module',

  salaryCard: {
    openFakeDoor: 'Open salary card fake door',
    requestInformation: 'Request salary card information',
    launchSurvey: 'Launch salary card survey',
  },
}
